<template lang="pug">
  .component-fleet-position
    .row(v-for="elem, index in value")
      DeleteConf(@click="value.splice(index, 1)")
      .column(v-for="(val, inx, key) in elem")
        SelectizeCategory(v-if="inx === 'vehicle_category_id'", v-model="value[index][inx]", @optionSelected="updateCategory($event, key)")
        BookingModeSelect(v-if="inx === 'booking_mode'", v-model="value[index][inx]")
</template>

<script>
  import SelectizeCategory from '../../structure/ui/lists/selectize/SelectizeCategory'
  import BookingModeSelect from '../../structure/BookingModeSelect'
  import DeleteConf from './DeleteConf'

  export default {
    name: 'FleetPositionConfiguration',
    components: {DeleteConf, BookingModeSelect, SelectizeCategory},
    methods: {
      updateCategory(val, index) {
        this.value[index].vehicle_category_id = val.id
      }
    },
    props: ['value', 'item']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// FleetPositionConfiguration.vue?32654e74